export const RoleApiUrls = {
  roles: '/api/role',
  notinrole: '/api/role/notinrole',
  save: '/api/role/save',
  userroles: '/api/role/userroles',
  usernotinrole: '/api/role/usernotinrole'
}

export const citiesByCountry: any = {
  'KWT': [
    { name: 'ALP', lat: 29.270849003811, lng: 47.84665041775832, orgId: 1 },
    { name: 'S2', lat: 28.756830, lng: 48.046600, orgId: 2 },
  ],
};
